import { Link } from "react-router-dom"
import "./Themes.css"
import picto from "../img/picto.png"
import medicorthologo from "../img/medicorthologo.png"

export default function Success({
	title = "Votre formulaire a bien été soumis !",
	message = "Suite à votre demande, vous allez recevoir les informations de paiement. Vous pourrez alors régler votre commande par carte bancaire, virement ou chèque. Le dispositif médical sera expédié dès réception du règlement",
}) {
	return (
		<div>
			<div className="header">
				<img className="img-logo" src={medicorthologo} alt="orthomedicortho-logo"></img>
			</div>
			<div className="div-central">
				<div className="title-formula">{title}</div>
				<div className="under-title-formula">{message}</div>
				<img className="img-picto" src={picto} alt="success"></img>
			</div>
			<div className="footer">
				<Link to="/" className="texte-footer">
					Espace Patient
				</Link>
				{/* <Link to="/pro" className="texte-footer">
					Espace Professionel
				</Link> */}
			</div>
		</div>
	)
}
